export const createProductFeature = `
    mutation createProductFeature($input: CreateProductFeatureInput!) {
        createProductFeature(input:$input) {
            id
            name
            description
            category
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
    }
}`;

export const updateProductFeature = `
    mutation updateProductFeature($input: UpdateProductFeatureInput!) {
        updateProductFeature(input:$input){
            id
            name
            description
            category
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

export const deleteProductFeature = `
    mutation deleteProductFeature($input: DeleteProductFeatureInput!) {
        deleteProductFeature(input:$input) 
}`;

export const enableProductFeature = `
    mutation activateProductFeature($id: ID!) {
        activateProductFeature(id: $id) {
            id
            name
            description
            category
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

export const disableProductFeature = `
    mutation cancelProductFeature($id: ID!) {
        cancelProductFeature(id: $id) {
            id
            name
            description
            category
            status
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;
